import { useEffect } from "react";
import { POIS } from "../../../../reduxStore/actions/main.js";
import { urlParameters } from "../../../../app/app.sideEffects/useURLParams.sideEffects.js";

export function useHandleURLParams(props) {
  useEffect(() => {
    const globalParams = new URLSearchParams(window.location.search);
    let destination = globalParams.get(urlParameters.destination);

    let poi = POIS.all.find((poi) => poi.uuid === destination);

    if (!poi) poi = POIS.all_objects[+destination];

    if (poi) {
      // #Markerfix Diese Stelle ist zur Verantwortung zu ziehen für die Map-Marker bei Einrichtungen mit Kindereinrichtungen.
      props.setCurrentFeature(poi);
      props.setPreOpen();
    }
    props.mapURLParamsHandled();
  }, []);
}
